<template>
  <section class="developer-success">
    <!--头部开始-->
    <header class="head">
      <i class="icon-success"></i>
    </header>
    <!--头部结束-->

    <h3 class="apply-result">申请成功</h3>

    <p class="apply-desc">恭喜您已通过验证，成为创造与魔法开发者的一员。</p>

    <!--操作开始-->
    <div class="handle">
      <router-link class="item go-course" to="/faq">阅读开发者新手教程</router-link>
      <router-link class="item go-home" to="/home">返回开发者首页</router-link>
    </div>
    <!--操作结束-->
  </section>
</template>

<script type="text/ecmascript-6">
  export default {
    // 审核通过页面
    name: 'developerSuccess',
    methods: {
      goHomeFn () {
        this.$router.push({path: 'home'})
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "developerSuccess.styl";
</style>



// WEBPACK FOOTER //
// src/views/developerSuccess/developerSuccess.vue